import { Component, Input } from '@angular/core';

@Component({
  selector: 'lotta-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  @Input() theme: string = 'light';
}
